import { render, staticRenderFns } from "./ClickableOptionCard.vue?vue&type=template&id=1fe48ca4&scoped=true"
import script from "./ClickableOptionCard.vue?vue&type=script&lang=js"
export * from "./ClickableOptionCard.vue?vue&type=script&lang=js"
import style0 from "./ClickableOptionCard.vue?vue&type=style&index=0&id=1fe48ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe48ca4",
  null
  
)

export default component.exports